import { ssGet, ssSet } from '../lib/storage';

// Идентификатор активной сессии поддержки «Посмотреть как» живёт в sessionStorage вкладки.
const KEY = 'labconnect.supportSession';

export const getSupportSessionId = (): string | null => ssGet(KEY);
export const setSupportSessionId = (id: string | null): void => ssSet(KEY, id);
